export default {
  title: 'Değerli İş Ortağımız, bu sayfayı görüntüleme yetkiniz bulunmamaktadır.',
  titleForDashboard: 'Değerli İş Ortağımız Trendyol satıcı paneline hoşgeldiniz.',
  message1: 'Erişiminiz olan sayfalara ana menüden veya aşağıdaki listeden ulaşabilirsiniz.',
  message2: 'Diğer menülere erişim ihtiyacınız varsa yöneticinizle iletişime geçerek, kullanıcınıza iligli rolü tanımlamasını talep edebilirsiniz.',
  message3: `Yöneticiniz tarafından yetki atanmadığı için <a href="{link}" class="unauthorized-link">{link}</a> sayfasını görüntüleyememektesiniz.`,
  menuTitle: {
    others: 'DİĞERLERİ',
  },
};
